export default __webpack_public_path__ + "static/mainLogo-ac24e747cb8334ade83a55e7aa0f8f61.png";